module.exports = __webpack_public_path__ + "static/media/ico-ok.a72bde52.svg";